import { Injectable } from '@angular/core';
import { EventsService } from './events.service';
import { NetworkService } from './network.service';
import { ToastrService } from 'ngx-toastr';
import {
  REMOVE_FROM_BASKET
} from '../../app.constants';

@Injectable()
export class CartService {
  private cart = {
    items: [],
    total: {
      formatted: '0',
      raw: 0
    }
  };

  constructor (
    private eventsBus: EventsService,
    private network: NetworkService,
    private toastr: ToastrService
  ) {}

  activate () {
    this.network
      .fetchCart()
      .then(response => {
        this.updateCart(response);
      });

    this.eventsBus
      .on(REMOVE_FROM_BASKET)
      .subscribe(this.removeProductFromCart);
  }

  addProductToCart (product) {
    this.network
      .addProductToCart(product.id)
      .then(response => {
        this.updateCart(response);
      })
      .catch(err => {
        if (err.status === 500) {
            this.toastr.error(err.error.message, 'Error');
        }
      });
  }

  removeProductFromCart (product) {
      this.network
          .removeProductFromCart(product.id)
          .then(response => {
              this.updateCart(response);
          });
  }

  isProductInTheCart(id) {
      const index = this.cart.items.findIndex(item => {
          return item.id === id;
      });
      return index > -1;
  }

  getCartScore () {
    return this.cart.items.length;
  }

  getCartItems () {
    return this.cart.items;
  }

  getTotal () {
    return this.cart.total;
  }

  clearCart () {
    this.network
      .clearCart()
      .then(response => {
        this.updateCart(response);
      })
  }

  private updateCart (newCart) {
    if (newCart.items && Array.isArray(newCart.items)) {
      this.cart.items.length = 0;

      newCart.items.map((item, index) => {
        this.cart.items.push(item.product);
        this.cart.items[index].states.trashed = item.states.trashed;
      });
    }

    this.cart.total.raw = newCart.total.raw;
    this.cart.total.formatted = newCart.total.formatted;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/cart.service.ts